import { render, staticRenderFns } from "./GoodsHistory.vue?vue&type=template&id=033949c6&scoped=true"
import script from "./GoodsHistory.vue?vue&type=script&lang=js"
export * from "./GoodsHistory.vue?vue&type=script&lang=js"
import style0 from "./GoodsHistory.vue?vue&type=style&index=0&id=033949c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "033949c6",
  null
  
)

export default component.exports